
import getUsps from '~/graphql/queries/getUsps.graphql';

export default {
    data() {
        return {
            items: null
        };
    },

    async fetch() {
        const site = this.$config.appMultisiteHandle;
        const { data } = await this.$gql.executeQuery(getUsps, { site });

        if (data && data.usps.items) {
            this.items = data.usps.items;
        }
    }
};
